export default "__VITE_ASSET__Bik0WLPo__"